// Fichier genere par `yarn svg:components` : ne pas modifier a la main.
// Source : public/images/school/menu/dashboard.svg
import * as React from 'react'
import type { SVGProps } from 'react'
const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 21" {...props}>
    <g fill="currentColor">
      <rect width={7.558} height={7.657} x={0.319} y={0.152} rx={1} />
      <rect width={7.558} height={7.657} x={12.761} y={0.152} rx={1} />
      <rect width={7.558} height={7.657} x={12.761} y={12.496} rx={1} />
      <rect width={7.558} height={7.657} x={0.319} y={12.496} rx={1} />
    </g>
  </svg>
)
export default SvgDashboard
